if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

onSubmitHandler(evt) {
  evt.preventDefault();
  
  // Prevent multiple forms from submitting - use class-level flag
  if (ProductForm.isSubmitting) {
    console.log('Blocked duplicate form submission');
    return;
  }
  ProductForm.isSubmitting = true;
  
  // Disable button immediately to prevent double clicks
  this.submitButton.disabled = true;
  
  // Prevent double submission
  if (this.submitButton.getAttribute('aria-disabled') === 'true') {
    this.submitButton.disabled = false;
    ProductForm.isSubmitting = false;
    return;
  }



this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

const formData = new FormData(this.form);

let quickAddSellElement = this.form.closest(".quick-add-modal__content-info");
if(quickAddSellElement){
  const sellingPlanInput = quickAddSellElement.querySelector('[name="selling_plan"]:checked');
  if (sellingPlanInput && sellingPlanInput.value) {
    formData.set('selling_plan', sellingPlanInput.value);
  }
}

if (this.cart) {
  formData.append(
    'sections',
    this.cart.getSectionsToRender().map((section) => section.id)
  );
  formData.append('sections_url', window.location.pathname);
  this.cart.setActiveElement(document.activeElement);
}
// Convert FormData to URL-encoded because this store's /cart/add.js
// doesn't attach selling_plan when the body arrives as multipart/form-data
// (an Appstle + Shopify-config quirk). URL-encoded POST works reliably.
const urlEncoded = new URLSearchParams();
for (const [k, v] of formData.entries()) {
  if (v instanceof Blob) continue; // skip File inputs, none expected here
  urlEncoded.append(k, v);
}
config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
config.body = urlEncoded.toString();
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      // UPDATED DEBUG CODE - REPLACE THE OLD ONE
      // console.log('=== CART ADD RESPONSE ===');
      // console.log('Full response:', response);
      // console.log('Item count:', response.item_count);
      // console.log('Has sections:', !!response.sections);
      // if (response.sections && response.sections['cart-drawer']) {
      //   console.log('Cart drawer HTML length:', response.sections['cart-drawer'].length);
      // }
      // console.log('========================');
      // END DEBUG CODE
      // console.log( "response.status==>" );
      // console.log( response );

      if( window.cartType == 'drawer' ){
        console.log("Modal open");
        console.log(this.closest('quick-add-modal'));
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart.renderContents(response);
        });
        if(this.closest('quick-add-modal')){
          this.closest('quick-add-modal').hide(true);
        }
      }


      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        setTimeout(() => {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        },500);  
      }


    })
    .catch((e) => {
      console.error(e);
    })


.finally(() => {
  this.submitButton.classList.remove('loading');
  this.submitButton.disabled = false;
  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
  this.querySelector('.loading__spinner').classList.add('hidden');
  
  // Reset the class-level flag
  setTimeout(() => {
    ProductForm.isSubmitting = false;
  }, 500);

  CartPerformance.measureFromEvent("add:user-action", evt);
});



}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
